import SolidButton from "./SolidButton";
import styles from './PulseButton.module.css';

export default function({repeatInfinite = true, ...props}) {

    const className = repeatInfinite ?
        styles.pulseButton
        : styles.pulseButtonOnLoad

    return (
        <SolidButton
            {...props}
            className={`${className} ${props.className ?? ''}`}
        ></SolidButton>
    )

}
